module.exports = __webpack_public_path__ + "static/img/200049.b5b49baf.png";